import { render, staticRenderFns } from "./TrGameControlPanelButtomV2.vue?vue&type=template&id=41d62a42&scoped=true&"
import script from "./TrGameControlPanelButtomV2.vue?vue&type=script&lang=js&"
export * from "./TrGameControlPanelButtomV2.vue?vue&type=script&lang=js&"
import style0 from "./TrGameControlPanelButtomV2.vue?vue&type=style&index=0&id=41d62a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d62a42",
  null
  
)

export default component.exports